import { isEmpty, isPlainObject, has, isFinite } from 'lodash';

import { getErrorCode, bytesToMegaBytes } from './utils';

export const ERROR_CODES = {
  required: 'required',
  invalid: 'invalid',
  invalid_coordinates: 'invalid_coordinates',
  positive_number: 'positive_number',
  number_greater_than: 'number_greater_than',
  number_greater_or_equal_than: 'number_greater_or_equal_than',
  file_too_large: 'file_too_large',
};

export const ERROR_MESSAGES = {
  [ERROR_CODES.required]: 'es requerido',
  [ERROR_CODES.invalid]: 'es inválido',
  [ERROR_CODES.invalid_coordinates]: 'coordenadas inválidas, es un campo requerido',
  [ERROR_CODES.positive_number]: 'debe ser un número positivo',
  [ERROR_CODES.number_greater_than]: ([_, min]) => `debe ser mayor a ${min}`,
  [ERROR_CODES.number_greater_or_equal_than]: ([_, min]) => `debe ser mayor o igual a ${min}`,
  [ERROR_CODES.file_too_large]: 'debe pesar 1MB como máximo',
};

export const isRequired = value => [
  getErrorCode(value === '' || value === undefined, ERROR_CODES.required),
  [value],
];

export const isRequiredWhen = assert => (value, values) => [
  getErrorCode(assert(values) && isRequired(value)[0], ERROR_CODES.required),
  [value, assert],
];

export const isEmail = value => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (isEmpty(value)) {
    return undefined;
  }
  return [getErrorCode(!re.test(String(value).toLowerCase()), ERROR_CODES.invalid), [value]];
};

export const isValidCoordinates = value => [
  getErrorCode(
    !(isPlainObject(value) && has(value, 'lat') && has(value, 'lng')),
    ERROR_CODES.invalid_coordinates,
  ),
  [value],
];

export const isPositiveNumber = value => [
  getErrorCode(!(isFinite(Number(value)) && Number(value) >= 0), ERROR_CODES.positive_number),
  [value],
];

export const isGreaterThan = minValue => value => [
  getErrorCode(!(Number(value) > minValue), ERROR_CODES.number_less),
  [value, minValue],
];

export const isGreaterOrEqualThan = minValue => value => [
  getErrorCode(!(Number(value) >= minValue), ERROR_CODES.number_greater_or_equal_than),
  [value, minValue],
];

export const isValidFile = fieldName => (value, values) => {
  const file = values[fieldName];

  if (file) {
    const filesize = bytesToMegaBytes(file.size);

    return [getErrorCode(filesize > 1, ERROR_CODES.file_too_large), [value, values]];
  }

  return [undefined, [value, values]];
};
